module.exports = __webpack_public_path__ + "img/profil1.6a0e8394.jpg";